export default __webpack_public_path__ + "static/media/6insta.84802441.jpg";